import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-match-error',
  imports: [MatCardModule],
  templateUrl: './match-error.component.html',
  styleUrl: './match-error.component.scss'
})
export class MatchErrorComponent {}
